import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Loader } from '@navent-jobs/ui-kit/components/loader'
import { CartBody, CartButtonsContainer, CartFooter, LegalAvisoRedirect, ContentLoader } from './mixins'
import { CartCoupon } from './components/CartCoupon'
import CartPrice from './components/CartPrice'
import { CartButtons } from './components/CartButtons'
import ProductCard from './components/ProductCard'
import { useFormatterCartTotalesAmount } from '../../../hooks/ecommerce/cart-totales-amount-hook'
import { useDataPerCountry } from '../../../hooks/ecommerce/data-per-country-hook'
import EmptyStateCartStore from './components/EmptyCart/index'
import { AppStore } from '../../../store'
import { ItemCart, ValorizedCartState } from '../../../store/cart-v2/valorized/types'
import { PurchaseState } from '../../../store/ecommerce/purchase/types'
import { closeCart } from '../../../store/cart-v2/modal/actionsToDo'

const showCardProducts = ({ valuesCart, statusCart, params }) => {
  return valuesCart.items.map((item: ItemCart) => {
    return (
      <ProductCard
        key={item.dataProduct.productId}
        index={item.dataProduct.productId}
        status={statusCart}
        params={params}
        item={item}
      />
    )
  })
}

const CartSection = ({ onClickHandler }) => {
  const dispatch = useDispatch()
  const {
    transactionStatus: { loading: loadingTransaction },
  } = useSelector<AppStore, PurchaseState>(({ purchaseStore }) => purchaseStore)
  const { cart: valuesCart, statusCart, params } = useSelector<AppStore, ValorizedCartState>(
    ({ cartStoreV2 }) => cartStoreV2.valorized
  )
  const { cartTotalesAmount } = useFormatterCartTotalesAmount()
  const { legalAvisoRedirect } = useDataPerCountry()
  const { t } = useTranslation()
  const cartIsEmpty = valuesCart.items.length === 0

  if (statusCart.loading && valuesCart.items.length === 0) {
    return (
      <ContentLoader>
        <Loader />
      </ContentLoader>
    )
  }
  return cartIsEmpty ? (
    <EmptyStateCartStore />
  ) : (
    <>
      <CartBody>{showCardProducts({ valuesCart, statusCart, params })}</CartBody>
      <CartFooter>
        <CartCoupon />
        <CartPrice cartTotalesAmount={cartTotalesAmount} />
        <CartButtonsContainer>
          {loadingTransaction ? (
            <ContentLoader>
              <Loader />
            </ContentLoader>
          ) : (
            <CartButtons onSave={() => onClickHandler()} onCancel={() => dispatch(closeCart())} isValid />
          )}
        </CartButtonsContainer>
        {legalAvisoRedirect && <LegalAvisoRedirect>{t('ecommerce.cart.legalAvisoRedirectDlocal')}</LegalAvisoRedirect>}
      </CartFooter>
    </>
  )
}
export default CartSection
